import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { type ReactNode, useMemo } from 'react'

import { BRPCarouselLayout } from '@/components/brp/BRPCarouselLayout'
import { CategoryTile } from '@/components/brp/CategoryTile'
import { TRANSLATION_KEYS } from '@/constants/localization'
import { getBrowseByCategoryData } from '@/features/search/utils/vertical-brp/getBrowseByCategoryData'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'

export const CategoryTypeCarousel = () => {
  const { query } = useRouter()
  const { t } = useTranslation([TRANSLATION_KEYS.SRP])

  const data = useMemo(() => getBrowseByCategoryData(t, query), [t, query])

  const handleTileClick = (tileLabel: string) => {
    trackEvent({
      action: GA_EVENT.BRPCarouselClick,
      label: `page=brp_landing_page;section=browse_by_category;tile=${tileLabel}`,
    })
  }

  const slides: ReactNode[] = data.map((item) => {
    const { label, url, description, imgSrc } = item

    return (
      <CategoryTile
        key={label}
        label={label}
        description={description}
        url={url}
        imageSrc={imgSrc}
        onClick={handleTileClick}
      />
    )
  })

  return (
    <BRPCarouselLayout
      title={t('srp:search_by_category.carousel.title')}
      carouselName="browse-by-category"
      slides={slides}
      slidesToShow={{ small: 1, medium: 2, large: 3 }}
    />
  )
}
